<template>
  <div v-if="!loading">
    <edit-password :showModal="showModal" @close="closeModal" :item="data" />
    <div class="p-3 position-relative">
      <img
        src="/images/profile_placeholder.svg"
        class="pl-2 mb-2 userPlaceholder"
      />
      <edit-user
        v-if="form"
        :item="data"
        @updateUser="updateUser"
        @hideForm="hideForm"
      />
      <div
        v-if="!form"
        class="w-100 d-flex justify-content-between flex-wrap mt-2"
      >
        <div class="w-50 px-2">
          <p class="font-weight-bold my-2 fs-16">
            {{ $t("field.name") }}
          </p>
          <p class="fs-14 text-gray-900">{{ data.name }}</p>
        </div>
        <div class="w-50 px-2">
          <p class="font-weight-bold my-2 fs-16">
            {{ $t("field.email") }}
          </p>
          <p class="fs-14 text-gray-900">{{ data.email }}</p>
        </div>
        <div class="w-50 px-2">
          <p class="font-weight-bold my-2 fs-16">
            {{ $t("field.phone") }}
          </p>
          <p class="fs-14 text-gray-900">{{ data.phone }}</p>
        </div>
        <div class="w-50 px-2" v-if="data.companies.length">
          <p class="font-weight-bold my-2 fs-16">
            {{ $t("field.company") }}(s)
          </p>
          <p class="fs-14 text-gray-900">{{ getCompanies }}</p>
        </div>
        <div class="w-50 px-2">
          <p class="font-weight-bold my-2 fs-16">
            {{ $t("field.department") }}
          </p>
          <p class="fs-14 text-gray-900">{{ data.department }}</p>
        </div>
        <div class="w-50 px-2">
          <p class="font-weight-bold my-2 fs-16">
            {{ $t("field.roles") }}
          </p>
          <p class="fs-14 text-gray-900">{{ data.roles[0].name }}</p>
        </div>
        <div class="w-100 px-2">
          <p class="font-weight-bold my-2 fs-16">
            {{ $t("field.signature") }}
          </p>
          <div class="mt-4">
            <img :src="data.file" class="w-auto mw-100" />
          </div>
        </div>
        <div class="edit position-absolute">
          <b-dropdown class="m-md-2" right>
            <template #button-content>
              <font-awesome-icon :icon="faEdit" class="mr-1" />
              {{ $t("messages.edit") }}
            </template>
            <b-dropdown-item @click.stop="showForm">{{
              $t("messages.edit_data")
            }}</b-dropdown-item>
            <b-dropdown-item @click.stop="openModal">{{
              $t("messages.edit_password")
            }}</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <spinner />
  </div>
</template>

<script>
import api from '@/api/users'
import { faEdit } from '@fortawesome/free-regular-svg-icons'
import editPassword from '@/views/account/passwordForm'
import editUser from '@/views/account/userForm'

export default {
  components: {
    editPassword,
    editUser
  },
  data: () => ({
    api,
    loading: true,
    data: [],
    companies: [],
    faEdit,
    showModal: false,
    form: false
  }),
  created() {
    this.init()
  },
  computed: {
    getCompanies() {
      const companiesNames = []
      this.data.companies.length
        ? this.data.companies.map(company => {
            companiesNames.push(company.name)
          })
        : ''
      return companiesNames.join()
    }
  },
  methods: {
    async init() {
      this.data = this.$auth.user()
      this.loading = false
    },
    openModal() {
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    hideForm() {
      this.form = false
    },
    async updateUser(name, email, phone, department, file) {
      this.loading = true

      Object.keys(this.data.companies).map(company => {
        this.companies.push(this.data.companies[company].id)
      })

      this.data['name'] = name
      this.data['email'] = email
      this.data['phone'] = phone
      this.data['role'] = this.data.roles[0].name
      this.data['department'] = department
      this.data['file'] = file

      const newData = {
        ...this.data,
        ...{ companies: this.companies.join() }
      }

      try {
        const response = await this.api.update({ ...newData }, this.data.id)

        if (response && response.data) {
          this.$toasted.success(
            this.$t('messages.updated', { item: 'Utilizador' })
          )
        } else if (
          response &&
          response.response &&
          response.response.data &&
          response.response.data.errors
        ) {
          this.$toasted.error(
            this.$t(Object.values(response.response.data.errors).join(' '))
          )
        } else {
          this.$toasted.error(this.$t('messages.unknown_error'))
        }
      } catch (e) {
        console.error(e)
      }

      this.loading = false
      this.form = false
    },
    showForm() {
      this.form = !this.form
    }
  }
}
</script>
<style lang="scss" scoped>
.edit {
  top: 0;
  right: 0;
}

.userPlaceholder {
  width: 8rem;
}
</style>
